import type { MarketConfig } from './types'

const fmt = new Intl.NumberFormat('ru-RU')

export const uz: MarketConfig = {
  code: 'uz',
  languages: [
    { code: 'ru', label: 'Русский', short: 'RU' },
    { code: 'uz', label: "O'zbek", short: 'UZ' },
    { code: 'en', label: 'English', short: 'EN' },
  ],
  defaultLanguage: 'ru',
  fallbackLanguage: 'ru',
  phoneCountry: 'uz',
  contact: {
    phone: { display: '+998 91 313 36 63', href: 'tel:+998913133663' },
    telegram: { handle: '@samly_uz', href: 'https://t.me/samly_uz' },
    instagram: { handle: '@samly.uz', href: 'https://www.instagram.com/samly.uz/' },
    website: { display: 'samly.uz', href: 'https://samly.uz' },
  },
  pricing: {
    // BRV (базовая расчётная величина). When the government revises it, change this one number.
    unitValue: 412_000,
    showUnit: true,
    fractionDigits: 0,
    numberLocale: 'ru-RU',
  },
  mockVenueName: 'Bahor',
  mockMoney: (uzs, opts) => (opts?.short ? `${Math.round(uzs / 1000)}К` : fmt.format(uzs)),
  unavailable: [],
  partnerLogos: ['click', 'payme', 'rahmat', 'yandex_eats', 'esc_pos', 'star_prnt'],
}
